
<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

<div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="20px">

  <div fxFlex="25" fxFlex.md="20" fxFlex.sm="50" fxFlex.xs="100" fxLayout="column" style="padding: 5px;" *ngIf="call_end && !is_migrating">
     
     <mat-card class="card option-card width-field-100 pointer"  (click)="zimbraLogin()">
       <mat-card-content class="card-content dashboard-card-content t_center">
           <img src="assets/static/labszimbra.png" name="labszimbra.png" style="height:48px;" />
           <h3> {{ "zimbrainstance.zimbra" | translate }} </h3>
       </mat-card-content>
     </mat-card>
     
   </div>
 
 </div>

<!-- MODELS MANAGEMENT -->
<div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="20px">

 <div fxFlex="25" fxFlex.md="20" fxFlex.sm="50" fxFlex.xs="100" fxLayout="column" style="padding: 5px;" *ngIf="is_migrating">
    
    <mat-card class="card option-card width-field-100">
      <mat-card-content class="card-content dashboard-card-content t_center">
          <i class="material-icons medium_icon software_color pointer" >
            query_builder
          </i>
          <h3> {{ "zimbrainstance.migrating" | translate }} </h3>
      </mat-card-content>
    </mat-card>
    
  </div>

</div>